import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import { fc } from 'i18n';
import Form from 'core/react/general/form/Form';
import { ZoneGuardsSelect } from '../zone-guards-select';
import { widgetsSelector } from 'core/redux/selectors/widgets';

import styles from './styles.module.css';

interface IWidgetConfigurationProps {
  reduxKey: string;
  uid: string;
}

export const WidgetConfiguration: FC<IWidgetConfigurationProps> = ({ reduxKey, uid }) => {
  const widgets = useSelector(widgetsSelector);

  const widgetData = widgets[reduxKey].map[uid].data;

  const [isEmergencyMode, setEmergencyMode] = useState<boolean>(widgetData?.isEmergencyMode || false);
  const [zoneGuard, setZoneGuard] = useState<number | null>(widgetData?.processorId || null);

  return zoneGuard ? (
    <div>
      <label>{fc('Zone Guard')}</label>
      <Form.Control
        controlType={ZoneGuardsSelect}
        controlName="processorId"
        value={zoneGuard}
        onChange={setZoneGuard}
      />

      <div className={styles.emergencySwitcher}>
        <Form.Control
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          controlType={Form.Control.Type.Checkbox}
          controlName="isEmergencyMode"
          value={isEmergencyMode}
          onChange={setEmergencyMode}
          label={fc('Emergency Mode')}
        />
      </div>
    </div>
  ) : null;
};
